import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import AudioPlayer from "components/ui/audio-player";
import { get } from "utils/api";
import { useFetch } from "hooks";
import { pauseVoicemailTimer, resumeVoicemailTimer } from "actions/auto-dialer";

const AWSVmailRecording = ({ id, ...props }) => {
  const dispatch = useDispatch();
  const { response: uri, fetchData } = useFetch({
    apiFn: vmID => get(`voicemails/${vmID}/uri`),
    defaultValue: ""
  });

  React.useEffect(() => {
    fetchData(id);
  }, [id]);

  const handleTriggerCountdown = (playAudio) => {
    if (playAudio) {
      dispatch(resumeVoicemailTimer());
    } else {
      dispatch(pauseVoicemailTimer());
    }
  };

  return uri ? (
    <AudioPlayer
      preloadAudio={"none"}
      src={uri}
      showAllFeatures={false}
      onTriggerCountdown={handleTriggerCountdown}
      {...props}
    />
  ) : (
    ""
  );
};

AWSVmailRecording.propTypes = {
  twilio_link: PropTypes.string,
  duration: PropTypes.number,
  id: PropTypes.string
};

export default AWSVmailRecording;
